import { useEffect } from 'react';
import { trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2';
import { useServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';
import { PDP_DIBS_PROMISE } from '../../constants/abTestsConstants';

export const usePdpDibsPromiseVariant = (): boolean => {
    const { isDibsPromiseVariant } = useServerVarsContext();
    return !!isDibsPromiseVariant;
};

export const useTrackPdpDibsPromiseVariant = (): void => {
    useEffect(() => {
        trackAbTestV2Variant(PDP_DIBS_PROMISE);
    }, []);
};
